import { render, staticRenderFns } from "./IndividualRegistration.vue?vue&type=template&id=741f3562&scoped=true"
import script from "./IndividualRegistration.vue?vue&type=script&lang=js"
export * from "./IndividualRegistration.vue?vue&type=script&lang=js"
import style0 from "./IndividualRegistration.vue?vue&type=style&index=0&id=741f3562&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741f3562",
  null
  
)

export default component.exports